import React from "react";
import SportLeagueHub from "./SportLeagueHub";

const MBLLeague = () => (
  <SportLeagueHub
    title="MBL Soccer"
    sport="MBL Soccer"
    standingsCaption="Standings: 3 pts per win, 1 per draw — from completed game scores."
  />
);

export default MBLLeague;
